import { Component, OnInit, Renderer2, ElementRef, Input } from '@angular/core';
import { TableColumn } from '../table.column';
import { TableElement } from '../table.element';
import { TableComponent } from '../table.component';

@Component({
  selector: 'app-widget',
  template: '<ng-content></ng-content>',
  styleUrls: ['./widget.component.scss']
})
export class WidgetComponent implements OnInit {
  @Input() table: TableComponent | null;
  @Input() tableElement: TableElement | null;
  @Input() tableColumn: TableColumn | null;

  _alterContent: any;
  _content: any;
  _icon: any;
  _color: any;

  // tslint:disable-next-line: deprecation
  constructor(protected _ngEl: ElementRef, protected _renderer: Renderer2) {
  }

  public setContent(table: TableComponent, tableElement: TableElement, tableColumn: TableColumn): void {
    this.table = table;
    this.tableElement = tableElement;
    this.tableColumn = tableColumn;
  }

  public getAlterContent() {
    if (typeof this._alterContent === 'undefined') {
      const content = this.tableColumn.getAlterContent(this.tableElement);

      if (content) {
        this._alterContent = content;
      } else {
        this._alterContent = "";
      }  
    }
    return this._alterContent;
  }

  public getContent() {
    if (typeof this._content === 'undefined') {
      if (this.tableColumn.getValueVisible() === true) {
        const content = this.tableColumn.getContent(this.tableElement);
  
        if (this.tableColumn.fixedLength !== null && content) {
          const cellNumber = new Number(content);

          if (cellNumber.toString() === 'NaN') {
            this._content = content;
          } else {
            this._content = cellNumber.toFixed(this.tableColumn.fixedLength);
          }
        } else {
          if (content !== null && typeof content !== 'undefined') {
            this._content = content.toString();
          } else {
            this._content = content;
          }
        }
      } else {
        this._content = '';
      }  
    }
    return this._content;
  }

  public getIcon(): string {
    if (typeof this._icon === 'undefined') {
      const column: TableColumn = this.tableColumn as TableColumn;

      if (column.iconDecorator) {
        this._icon = column.getIcon(this.tableElement);
      } else if (column.icon) {
        if (column.icon && this.tableElement.getData().icon) {
          this._icon = this.tableElement.getData().icon;
        } else {
          this._icon = column.icon;
        }  
      } else {
        this._icon = '';
      }
    }
    return this._icon;
  }

  public getStyles(): string {
    if (this.tableElement.styles) {
      if (typeof this.tableElement.styles === 'string') {
        if (this.tableElement.styles) {
          return this.tableElement.styles.toString();
        } else {
          return null;
        }
      } else {
        return this.tableElement.styles[this.tableColumn.column];
      }  
    } else {
      return null;
    }
  }

  public getTranslateParams() {
    if (this.tableElement.getData().translateParams) {
      return this.tableElement.getData().translateParams;
    } else {
      return null;
    }
  }

  get ignoreTranslate() {
    return this.tableColumn.ignoreTranslate;
  }

  public get element(): any {
      return this._ngEl.nativeElement;
  }
  removeFromParent() {
        this._ngEl.nativeElement.remove();
  }
  ngOnInit(): void {
      this._renderer.setStyle(this._ngEl.nativeElement, 'widget', true);
  }
}
